var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0598 13.3332C13.1138 13.3332 12.262 13.7283 11.6556 14.3608L6.46402 11.1343C6.59322 10.7797 6.66733 10.3991 6.66733 9.9995C6.66733 9.60088 6.59322 9.21979 6.46402 8.86524L11.6556 5.63874C12.262 6.27122 13.1138 6.66633 14.0598 6.66633C15.8996 6.66633 17.392 5.17402 17.392 3.33317C17.392 1.49181 15.8996 0 14.0598 0C12.2179 0 10.7246 1.49181 10.7246 3.33317C10.7246 3.73229 10.7987 4.11338 10.9269 4.46793L5.73739 7.69393C5.12995 7.06195 4.27913 6.66633 3.33417 6.66633C1.49231 6.66633 0 8.15865 0 9.9995C0 11.8404 1.49231 13.3332 3.33417 13.3332C4.27913 13.3332 5.12995 12.9376 5.73739 12.3056L10.9269 15.5321C10.7987 15.8866 10.7246 16.2677 10.7246 16.6668C10.7246 18.5077 12.2179 20 14.0598 20C15.8996 20 17.392 18.5077 17.392 16.6668C17.392 14.8255 15.8996 13.3332 14.0598 13.3332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.e9be40c801feab530d3db9c3cfb6fa45.svg";
export { ForwardRef as ReactComponent };